<template>
    <submenu-page
        eyebrow="SCHOOL OPERATIONS"
        title="Inventory and Assets"
        description="Track school assets, stock, purchase orders, suppliers and maintenance."
        count-label="inventory tools"
    >
        <SubMenu />
    </submenu-page>
</template>
<script>


import SubMenu from './SubMenu.vue';
export default {
  components: {
    SubMenu
  },
  data() {
    return {
      accessDetails: null,
    };
  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user'];   
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch('auth/Logout')
      this.$router.push('/login')
    }
  }
};
</script>
<style></style>
